//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { FormField } from '@campaigns/components/shared/product-details-modal/form/FormField';
import { ProductDetailsFieldLabels } from '@campaigns/constants/ProductDetailsModalFieldLabels';
import { URL_REGEX_RULE } from '@campaigns/constants/sampling/SamplingProductValidationRulesConstants';

interface ProductMetaFieldsProps {
  isViewOnly: boolean;
}

export const ProductMetaFields = ({ isViewOnly }: ProductMetaFieldsProps) => {
  return (
    <Container>
      {/* Product Brand Field */}
      <FormField
        inputType='text'
        isViewOnly={isViewOnly}
        label={ProductDetailsFieldLabels.brand}
        labelHelpText=''
        name='brand'
        placeholder=''
        rules={{
          required: {
            value: true,
            message: 'Please enter a product brand',
          },
        }}
        visibleToParticipants={true}
        width='half'
      />

      {/* Product Category Field */}
      <FormField
        inputType='text'
        isViewOnly={isViewOnly}
        label={ProductDetailsFieldLabels.category}
        labelHelpText='Enter the category to which the product belongs.'
        name='category'
        placeholder=''
        rules={{
          required: {
            value: true,
            message: 'Please enter a product category',
          },
        }}
        visibleToParticipants={true}
        width='half'
      />

      {/* Product URL Field (optional) */}
      <FormField
        inputType='text'
        isViewOnly={isViewOnly}
        label={ProductDetailsFieldLabels.pdpUrl}
        labelHelpText=''
        name='pdpUrl'
        placeholder='https://'
        rules={{
          pattern: {
            value: URL_REGEX_RULE,
            message: 'Please enter a valid URL',
          },
        }}
        visibleToParticipants={true}
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacings[3]};
`;
